var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasLink)?_c('nuxt-link',{staticClass:"tag",attrs:{"to":_vm.link}},[_vm._v(_vm._s(_vm.text))]):_c('span',{staticClass:"tag",attrs:{"to":_vm.link}},[_vm._v(_vm._s(_vm.text))])}
var staticRenderFns = []

export { render, staticRenderFns }